import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Returns the current public visibility of the gallery (Iter39 flag).
 *
 * Used by every navigation menu (client / employee / admin / homepage
 * footer) to hide the "Galeria" link when the admin has switched the
 * gallery off.
 *
 * Optimistic default: TRUE — we'd rather briefly show the link and hide
 * it on next render than the opposite (which would feel laggy on the
 * happy path).
 */
export default function useGalleryEnabled() {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/gallery/status")
      .then(({ data }) => { if (alive) setEnabled(data.enabled !== false); })
      .catch(() => { /* keep optimistic default */ });
    return () => { alive = false; };
  }, []);

  return enabled;
}
